export default __webpack_public_path__ + "static/media/speed.150c0cf9.svg";